const Section = ({ title, children }) => (
  <section className="space-y-2">
    <h2 className="text-base font-semibold text-slate-800">{title}</h2>
    {children}
  </section>
);

const LegalLayout = ({ title, updated, children }) => (
  <div className="min-h-screen bg-slate-50 py-12 px-6">
    <div className="max-w-2xl mx-auto bg-white border border-slate-200 rounded-xl p-8 space-y-6">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">{title}</h1>
        <p className="text-xs text-slate-400 mt-1">Última actualización: {updated}</p>
      </div>
      <div className="text-sm text-slate-600 space-y-5 leading-relaxed">{children}</div>
      <a href="/" className="inline-block text-sm text-[#D9381E] hover:underline">← Volver a ITACATE FINANCE</a>
    </div>
  </div>
);

export function Privacidad() {
  return (
    <LegalLayout title="Política de Privacidad" updated="septiembre de 2026">
      <Section title="1. Responsable del tratamiento">
        <p><strong>ITACATE TAQUERÍA MEXICANA</strong> (en adelante, «el Responsable»), con establecimientos en
          Fuengirola y Málaga (España). Contacto para cualquier cuestión relacionada con la protección de datos
          personales: <strong>itacatetaquerias@gmail.com</strong>.</p>
      </Section>
      <Section title="2. Descripción del servicio">
        <p>ITACATE FINANCE es una aplicación web interna de gestión financiera del negocio. Centraliza las ventas
          del TPV, las facturas de proveedores, los movimientos bancarios, los cortes de caja diarios y las
          nóminas, con el fin de llevar el control contable y financiero de la empresa. El acceso está restringido
          al personal autorizado mediante cuenta de usuario; no es un servicio dirigido al público general.</p>
      </Section>
      <Section title="3. Datos que recopilamos y cómo los obtenemos">
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Usuarios internos autorizados:</strong> nombre, dirección de correo electrónico, contraseña
            (almacenada cifrada), rol dentro de la aplicación y registro de auditoría de las acciones realizadas.
            Se obtienen directamente del administrador al crear la cuenta y del propio uso de la aplicación.</li>
          <li><strong>Facturas y tickets de proveedores:</strong> documentos (PDF o imagen) subidos por los
            usuarios o importados desde Google Drive, junto con los datos extraídos automáticamente de ellos
            mediante OCR: nombre y NIF/CIF del proveedor, número y fecha de factura, importes (base, IVA, total),
            moneda y líneas de detalle.</li>
          <li><strong>Movimientos bancarios y de caja:</strong> extractos bancarios importados por los usuarios
            (fecha, concepto, importe, saldo) y movimientos registrados en los cortes de caja diarios.</li>
          <li><strong>Datos de ventas:</strong> tickets y resúmenes diarios de venta procedentes del TPV
            (Loyverse), sin datos identificativos de clientes finales.</li>
          <li><strong>Datos de personal:</strong> nóminas y datos laborales de los empleados (nombre, NIF, puesto,
            horas de contrato, importes salariales), necesarios para el control de costes de personal.</li>
          <li><strong>Datos técnicos de conexión:</strong> dirección IP, fecha y hora de acceso y registros de
            seguridad (intentos de inicio de sesión), con la única finalidad de proteger el servicio.</li>
        </ul>
      </Section>
      <Section title="4. Integración con Google Drive (uso de datos de Google)">
        <p>La aplicación puede conectarse, exclusivamente a elección del administrador, con una cuenta de Google
          Drive de la empresa. En ese caso:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Se solicita el permiso <strong>drive.readonly</strong> (solo lectura). La aplicación únicamente
            <strong> lista, lee y descarga</strong> los archivos de las carpetas de Google Drive que el
            administrador selecciona expresamente, con el único fin de importar facturas y tickets a la
            contabilidad interna.</li>
          <li>La aplicación <strong>nunca crea, modifica, comparte, ni elimina</strong> archivos de Google Drive,
            ni accede a ningún otro dato de la cuenta de Google.</li>
          <li>Los datos obtenidos de Google Drive se utilizan únicamente para la finalidad descrita y no se
            emplean para publicidad, perfilado, venta de datos ni ningún otro propósito. No se transfieren a
            terceros ajenos al funcionamiento del servicio.</li>
          <li>Las credenciales de acceso (tokens OAuth 2.0) se almacenan cifradas y se usan solo para esta
            integración. El administrador puede revocar el acceso en cualquier momento desde la propia aplicación
            (Configuración → Google Drive → Desconectar) o desde la página de permisos de su cuenta de Google
            (myaccount.google.com/permissions).</li>
          <li>El uso y la transferencia a cualquier otra aplicación de la información recibida de las API de
            Google se ajustan a la <em>Política de datos de usuario de los servicios API de Google</em>, incluidos
            los requisitos de uso limitado («Limited Use requirements»).</li>
        </ul>
      </Section>
      <Section title="5. Finalidad y base jurídica del tratamiento">
        <p>Los datos se tratan exclusivamente para la gestión contable, financiera, fiscal y administrativa del
          negocio. La base jurídica es el interés legítimo del Responsable en la gestión de su actividad, la
          ejecución de la relación laboral con los empleados y el cumplimiento de las obligaciones legales y
          fiscales aplicables. No se toman decisiones automatizadas con efectos jurídicos ni se elaboran perfiles.</p>
      </Section>
      <Section title="6. Destinatarios y encargados de tratamiento">
        <p>No se venden ni ceden datos personales a terceros con fines comerciales. Para prestar el servicio
          intervienen proveedores técnicos que actúan como encargados de tratamiento bajo las garantías
          adecuadas: servicios de alojamiento en la nube, almacenamiento seguro de archivos, envío de correo
          electrónico transaccional (avisos internos) y servicios de OCR para la lectura de documentos. Los datos
          de Google Drive no se comparten con estos proveedores salvo lo estrictamente necesario para procesar
          los documentos importados (OCR), y nunca con fines publicitarios.</p>
      </Section>
      <Section title="7. Transferencias internacionales">
        <p>Algunos de los proveedores técnicos citados pueden tratar datos fuera del Espacio Económico Europeo.
          En tal caso, las transferencias se amparan en decisiones de adecuación o en cláusulas contractuales
          tipo aprobadas por la Comisión Europea.</p>
      </Section>
      <Section title="8. Plazo de conservación">
        <p>Los datos se conservan mientras sean necesarios para la gestión del negocio y, en el caso de la
          documentación contable y fiscal, durante los plazos de prescripción exigidos por la normativa vigente
          (con carácter general, 4 años en materia fiscal y 6 años en materia contable).</p>
      </Section>
      <Section title="9. Medidas de seguridad">
        <p>El acceso a la aplicación requiere autenticación individual por usuario y contraseña, con bloqueo
          temporal tras intentos fallidos, control de acceso por roles y registro de auditoría de las acciones
          relevantes. Todas las comunicaciones se realizan cifradas mediante HTTPS y las credenciales de
          integraciones externas se almacenan cifradas.</p>
      </Section>
      <Section title="10. Cookies">
        <p>La aplicación utiliza únicamente cookies técnicas estrictamente necesarias para mantener la sesión del
          usuario autenticado. No utiliza cookies publicitarias, de análisis ni de terceros con fines de
          seguimiento.</p>
      </Section>
      <Section title="11. Derechos de los interesados">
        <p>Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento
          y portabilidad escribiendo a <strong>itacatetaquerias@gmail.com</strong>. Si consideras que el
          tratamiento no se ajusta a la normativa, puedes reclamar ante la Agencia Española de Protección de
          Datos (www.aepd.es).</p>
      </Section>
      <Section title="12. Cambios en esta política">
        <p>Esta política puede actualizarse para reflejar cambios en el servicio o en la normativa. La fecha de
          la última actualización figura al inicio de este documento.</p>
      </Section>
    </LegalLayout>
  );
}

export function Condiciones() {
  return (
    <LegalLayout title="Condiciones del Servicio" updated="septiembre de 2026">
      <Section title="1. Objeto">
        <p>ITACATE FINANCE es una aplicación interna de gestión financiera de uso exclusivo del personal
          autorizado de ITACATE TAQUERÍA MEXICANA. Estas condiciones regulan el acceso y uso de la aplicación.</p>
      </Section>
      <Section title="2. Acceso y cuentas de usuario">
        <ul className="list-disc pl-5 space-y-1">
          <li>El acceso es personal e intransferible. Cada usuario es responsable de la confidencialidad de sus
            credenciales y de la actividad realizada con su cuenta.</li>
          <li>Los permisos dentro de la aplicación dependen del rol asignado por el administrador.</li>
          <li>El administrador puede crear, modificar o desactivar cuentas según las necesidades del negocio.</li>
        </ul>
      </Section>
      <Section title="3. Uso permitido">
        <p>La aplicación debe utilizarse únicamente para la gestión financiera del negocio. No está permitido
          intentar acceder a datos de otros usuarios sin autorización, interferir en el funcionamiento del
          servicio ni utilizar la información contenida para fines ajenos a la empresa.</p>
      </Section>
      <Section title="4. Datos e integraciones">
        <p>La información financiera mostrada (ventas, gastos, saldos, previsiones) se genera a partir de los
          datos introducidos por los usuarios y de las integraciones configuradas (TPV Loyverse, Google Drive y
          extractos bancarios). Dicha información tiene carácter orientativo para la gestión interna y no
          sustituye la contabilidad oficial ni el asesoramiento de la gestoría.</p>
        <p>La integración con Google Drive es de solo lectura y puede ser conectada o revocada por el
          administrador en cualquier momento.</p>
      </Section>
      <Section title="5. Disponibilidad">
        <p>El servicio puede interrumpirse temporalmente por tareas de mantenimiento, actualizaciones o causas
          técnicas ajenas al Responsable. No se garantiza disponibilidad ininterrumpida.</p>
      </Section>
      <Section title="6. Responsabilidad">
        <p>El Responsable no responde de las decisiones tomadas exclusivamente a partir de la información
          orientativa de la aplicación, ni de los errores derivados de datos incorrectos introducidos por los
          usuarios o procedentes de las integraciones externas.</p>
      </Section>
      <Section title="7. Propiedad intelectual">
        <p>La aplicación, su diseño y su contenido son titularidad de ITACATE TAQUERÍA MEXICANA. Queda prohibida
          su reproducción o distribución fuera del ámbito autorizado.</p>
      </Section>
      <Section title="8. Legislación aplicable">
        <p>Estas condiciones se rigen por la legislación española. Para cualquier controversia serán competentes
          los tribunales del domicilio del Responsable, salvo fuero imperativo distinto.</p>
      </Section>
      <Section title="9. Contacto">
        <p>Para cualquier incidencia o consulta sobre el servicio: <strong>itacatetaquerias@gmail.com</strong>.</p>
      </Section>
    </LegalLayout>
  );
}
